import BaseRepository from './base.repository';

class BloodTestResultsRepository extends BaseRepository {
  constructor() {
    super('/blood-test-results');
  }

  getLatest() {
    return this.client.get('');
  }

  getOptions() {
    return this.client.get('/options');
  }

  getTrends(bloodTestMainUnique, params) {
    return this.client.get(`/trends/${bloodTestMainUnique}`, params);
  }
}

export default new BloodTestResultsRepository();
